import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  background: {
    backgroundColor: "#E3E3E3",
  },
  card: {
    backgroundColor: "#005AAB",
  },
  container: {
    alignItems: "center",
  },
  text: {
    textAlign: "center",
    fontWeight: "bold",
    textTransform: "uppercase",
    color: "white",
  },
  help: {
    color: "white",
  },
  link: {
    textDecorationLine: "underline",
  },
  h2: {
    fontSize: "$h2",
  },
  marginTop: {
    marginTop: "10vh",
  },
});
